import StackedImages from "../StackedImage";
import { Img, Heading } from "./..";
import React from "react";

interface Props {
  className?: string;
  inspirationText?: React.ReactNode;
  type?: string;
}

const renderAssets = (type) => {
  if (type === "inspiredBy") {
    return <iframe
      width="100%"
      height="130px"
      src="https://www.youtube.com/embed/ilSJR_vTHdc?start=6"
      title="YouTube video player"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    ></iframe>
  } else if (type === "boostRevenue") {
    return <Img src="/images/new-landing-page/boostRevenue.svg" alt="Image" className="h-[130px]" />
  } else if (type === "businessEcosystem") {
    return <StackedImages />
  } else if (type === "traditionalSoftware") {
    return <Img src="/images/new-landing-page/traditionalSoftware.svg" alt="Image" className="h-[130px]" />
  }
}

export default function MultilingualPlatformInspiration({ inspirationText, type, ...props }: Props) {
  return (
    <div
      {...props}
      className={`${props.className} flex flex-col w-full md:w-full gap-3 p-6 sm:p-5 bg-gray-100_01 shadow-xs rounded-md overflow-clip`}
    >
      <Heading style={{zIndex: 10}} as="p" className="w-full !font-inter text-[18px] font-medium leading-[150%] !text-gray-900 bg-gray-100_01 sm:text-center">
        {inspirationText}
      </Heading>
      <div className="relative flex justify-center self-stretch md:p-5">
        {renderAssets(type)}
      </div>
    </div>
  );
}
